import { FC, ReactNode, CSSProperties } from 'react';
import {BsJustifyLeft} from 'react-icons/bs';
type Iprops = {
  children: ReactNode;
  style?: CSSProperties;
  className?: string;
};

const Card: FC<Iprops> = ({ style = {}, children, className }) => {
  return (
    <div style={{
      borderRadius: '0.375rem',
      background: 'white',
      boxShadow: '0 10px 30px 0 rgba(98, 89, 202, 0.05)',
      ...style
    }} className={className}>
      {children}
    </div>
  );
};
export const CardHeading:FC<{heading:string,subHeading?:string,children?:ReactNode}> = ({ heading = '', subHeading = '',children }) => {
  return (

    <div style={{
      borderRadius: '0.625rem 0.625rem 0 0',
      display: 'flex',
      alignItems: 'center',
      padding: "1.2rem 1rem",
      borderBlockEnd:'1px solid var(--border-color)'
    }}>
      <BsJustifyLeft style={{marginRight:'1rem',fontSize:'1.3rem'}}/>
      <div style={{
      }}>
        <div
          style={{
            marginBlockEnd: 0,
            fontSize: '1.05rem',
            fontWeight: '600',
            textTransform: 'capitalize'
          }}
        >{heading}</div>
        {subHeading && <span>{subHeading}</span>}
      </div>
      {children && children}
    </div>
  )
}
export const CardBody: FC<Iprops> = ({ style = {}, children, className='' }) => {
  return (
    <div className={className} style={{
      ...style
    }}>
      {children}
    </div>
  )
}
export default Card;
